export class UnitAmount {
  constructor(
    public readonly currency: string,
    public readonly amount: number,
  ) {
  }
}
